import { FC, useMemo } from 'react';
import { FeaturesetValues } from '../../network';
import { SagittalMetric } from './SagittalMetric';
import { MetricKeyEnum } from '../LayerControls/layerStore';

interface UpperSagittalProps {
  featuresetValues: FeaturesetValues | undefined;
}

export const UpperSagittal: FC<UpperSagittalProps> = ({ featuresetValues }) => {
  const result = useMemo(() => {
    try {
      const sagittalDisplayDict = featuresetValues?.sagittal_display_dict;
      if (!sagittalDisplayDict) {
        throw new Error(
          'Sagittal display dict is not defined in upper sagittal'
        );
      }
      return sagittalDisplayDict.max_upper_sagittal;
    } catch (error) {
      console.error(error);
      return null;
    }
  }, [featuresetValues]);

  if (!result) {
    return null;
  }

  return (
    <SagittalMetric
      sagittalSpineMetrics={result}
      layerKey={MetricKeyEnum.MaxUpperSagittal}
    />
  );
};
